<template>
  <div class="app-container">
    <el-dialog
      class="dataDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="Условия передачи данных"
      :visible.sync="centerDialogVisible"
      center
    >
      <span
        >Настоящим я даю свое согласие ООО "Ласир", место нахождения: 109456, г
        Москва, Рязанский проспект, 75к4, на обработку (включая поручение
        обработки моих персональных данных третьим лицам) своих персональных
        данных в соответствии с требованиями Федерального закона «О персональных
        данных» № 152-ФЗ от 27 июля 2006 года (под обработкой персональных
        данных в соответствии со ст. 3 152-ФЗ «О персональных данных» понимаются
        действия (операции) с персональными данными физических лиц, включая
        сбор, систематизацию, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, распространение (в том числе
        передачу), обезличивание, блокирование, удаление, уничтожение), в целях
        определения необходимого мне коммерческого предложения, информирования
        меня о нём, заключения с ООО "Ласир" и/или контрагентами ООО "Ласир"
        договора, а также в любых других целях, прямо или косвенно связанных с
        предложением иных продуктов ООО "Ласир", и направления мне информации о
        новых продуктах и услугах ООО "Ласир" и/или его контрагентов. Я даю
        согласие контрагентам ООО "Ласир" на обработку всех моих персональных
        данных, имеющихся в распоряжении/доступе ООО "Ласир" и/или контрагентов
        ООО "Ласир", в том числе с целью информирования меня об услугах
        контрагентов. Указанное согласие дано на срок 10 (Десять) лет, а в
        случае его отзыва обработка моих персональных данных должна быть
        прекращена ООО "Ласир" и/или третьими лицами и данные уничтожены при
        условии расторжения договора и полного погашения задолженности по
        договору в срок не позднее 1 (одного) года с даты прекращения действия
        договора. Я даю согласие на предоставление ООО "Ласир" и/или
        контрагентами ООО "Ласир" всей имеющейся обо мне информации в объеме, в
        порядке и на условиях, определенных Федеральным законом «О кредитных
        историях» № 218-ФЗ от 30 декабря 2004 года, во все бюро кредитных
        историй, включенные в государственный реестр бюро кредитных историй, а
        также на получение кредитного отчета из вышеобозначенных бюро для
        заключения договора и в течение срока действия договора. Я даю согласие
        на получение мной рекламы, рассылки, в том числе по сети подвижной
        радиотелефонной связи, от ООО "Ласир", его контрагентов и аффилированных
        лиц.</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button class="fillGreenBtn" @click="agree">Согласен</el-button>
      </span>
    </el-dialog>
    <noecp v-if="ecp === 'no'"></noecp>
    <!--:thumbprint="thumbprint"-->
    <ecp
      v-if="ecp === 'yes'"
      :arr="arr"
      :formComp="form"
      :banks="banks"
      :noSignDocument="noSignDocument"
      :offer="offer"
      :offers="offers"
      :links="links"
    ></ecp>
    <checkecp v-if="ecp === 'check'"></checkecp>
    <!--<wronginn v-if="show && ecp !== 'check'"></wronginn>-->
    <wronginn v-if="ecp === 'wronginn'"></wronginn>
    <noinn v-if="ecp === 'noinn'"></noinn>
  </div>
</template>

<script>
import { isFirefox, isOpera } from "@/functions/browsers";
import {
  getUserCertificates,
  Certificate,
  getSystemInfo,
  isValidSystemSetup,
  createSignature
} from "crypto-pro";
import noecp from "../noEcp/index";
import ecp from "../ecp/index";
import checkecp from "../checkEcp/index";
import wronginn from "../wrongEcp/index";
import noinn from "../noInn/index";
import { getinfo, error } from "@/api/sign";
export default {
  name: "index",
  components: {
    noecp,
    ecp,
    checkecp,
    wronginn,
    noinn
  },
  data() {
    return {
      centerDialogVisible: true,
      innArr: [],
      arr: [],
      //thumbprint: "",
      systemInfo: "",
      ecp: "",
      //show: false,
      banks: [],
      noSignDocument: [],
      offer: false,
      offers: [],
      links: [],
      form: {}
    };
  },
  created() {
    //console.log(this.$store.state.helper.id);
  },
  methods: {
    async agree() {
      this.centerDialogVisible = false;
      // let ua = navigator.userAgent;
      // if (ua.search(/Firefox/) > 0 || ua.search(/OPR/) > 0 || ua.search(/OP/) > 0){
      //     this.ecp= "check"
      // }
      if (isFirefox || isOpera) {
        this.ecp = "check";
      }
      let a = await this.displaySystemInfo();
      //let a = true;
      //  console.log(a)
      if (a) {
        //начало удалить
        //   this.arr=[
        //       {issuerName: "CN='ООО КОМПАНИЯ ТЕНЗОР', O='ООО КОМПАНИЯ ТЕНЗОР', OU=Удостоверяющий центр, STREET='Московский проспект, д. 12', L=г. Ярославль, S=76 Ярославская область, C=RU, ИНН=007605016030, ОГРН=1027600787994, e=ca_tensor@tensor.ru",
        //   name: 'ООО ПРОФ АНАЛИТИКС',
        //   subjectName: "ОГРН=1167746772181, СНИЛС=14381048850, INN=7733296577, e=info@notjustasite.com, O='ПРОФ АНАЛИТИКС', T=ГЕНЕРАЛЬНЫЙ ДИРЕКТОР, CN='ООО ПРОФ АНАЛИТИКС', SN=Горностаев, G=Иван Владимирович, C=RU, L=МОСКВА, S=77 ГОРОД МОСКВА, STREET='УЛИЦА СВОБОДЫ, ДОМ 50, ПОМЕЩЕНИЕ 7'",
        //   thumbprint: 'B234A6D3B7A7D8A4F31B1BEA09E2B2A28B578957',
        //   validFrom: "2020-08-04T13:09:17.000Z",
        //   validTo: "2021-11-04T13:09:17.000Z"}
        //   ]
        //   this.arr=[{"_cadesCertificate":{objid:12},
        //       name:"Гутюм Николай федорович",
        //       issuerName:"CN='ООО АСТРАЛ-М', O='ООО АСТРАЛ-М', STREET=Шоссе Энтузиастов д. 56 стр. 32 офис 214, L=г. Москва, S=77 г. Москва, C=RU, INN=007720623379, OGRN=1087746806311, e=ca@astralm.ru",
        //       subjectName:"CN=Гутюм Николай федорович, SN=Гутюм, G=Николай федорович, SNILS=18913387409, INN=772585200724, e=gutium.nf@gmail.com, OGRNIP=321774600109151",
        //       thumbprint:"270F65723593F67686A4635333BDAD8905968112",
        //       validFrom:"2021-06-04T11:02:43.000Z",
        //       validTo:"2022-06-04T11:02:43.000Z"}
        //       ]
        //   this.arr = [
        //         {"_cadesCertificate":{"objid":30},
        //             name:'ООО "ОМЕГА"',
        //             issuerName:'CN="АО СКБ Контур", O="АО ПФСКБ Контур", OU=Удостоверяющий центр, STREET="улица Народной воли, строение 19А", L=Екатеринбург, S=66 Свердловская область, C=RU, ИНН=006663003127, ОГРН=1026605606620, e=ca@skbkontur.ru',
        //             subjectName:'CN="ООО "ОМЕГА", SN=Колесникова, G=Ирина Геннадьевна, C=RU, S=50 Московская область, L=Химки, STREET="УЛ РАБОЧАЯ, ДОМ 2А, КОРП 2, ПОМ 128", O="ООО "ОМЕГА"", T=Генеральный Директор, ОГРН=1185053043372, СНИЛС=02993117674, ИНН=165911859220, e=omegairina2018@gmail.com, OID.1.2.643.100.4=5047218298',
        //             thumbprint:"4D8BF881530D7A6154738D9C2BF43B2B8F995D5E",
        //             inn:"165911859220",
        //             validTo: "2021-11-04T13:09:17.000Z"}
        //     ]
        //   this.arr = [
        //       {
        //           "_cadesCertificate": {
        //               "objid": 12
        //           },
        //           "name": "Хакиева Элеонора Алиевна",
        //           "issuerName": "CN=Федеральное казначейство, O=Федеральное казначейство, C=RU, L=Москва, STREET='Большой Златоустинский переулок, д. 6, строение 1', ОГРН=1047797019830, ИНН=007710568760, S=г. Москва, E=uc_fk@roskazna.ru",
        //           "subjectName": "CN=Хакиева Элеонора Алиевна, SN=Хакиева, G=Элеонора Алиевна, O='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ ВОЕННОЕ ОБРАЗОВАТЕЛЬНОЕ УЧРЕЖДЕНИЕ ВЫСШЕГО ОБРАЗОВАНИЯ =АКАДЕМИЯ ГРАЖДАНСКОЙ ЗАЩИТЫ МИНИСТЕРСТВА РОССИЙСКОЙ ФЕДЕРАЦИИ ПО ДЕЛАМ ГРАЖДАНСКОЙ ОБОРОНЫ, ЧРЕЗВЫЧАЙНЫМ СИТУАЦИЯМ И ЛИКВИДАЦИИ ПОСЛЕДСТВИЙ СТИХИЙНЫХ БЕДСТВИЙ', L=Химки, S=Московская область, C=RU, E=e.artemenko@amchs.ru, СНИЛС=18605612272, ИНН=504796301027",
        //           "thumbprint": "FCB487145D0EEB221A2C8FC6804C4B4C5763A2F6",
        //           "validFrom": "2021-02-11T12:01:31.000Z",
        //           "validTo": "2022-05-11T12:01:31.000Z",
        //           "inn": "504796301027"
        //       },
        //       {
        //           "_cadesCertificate": {
        //               "objid": 13
        //           },
        //           "name": "ФГБВОУ ВО =АКАДЕМИЯ ГРАЖДАНСКОЙ ЗАЩИТЫ МЧС РОССИИ=",
        //           "issuerName": "CN='Общество с ограниченной ответственностью Сертум-Про', O='Общество с ограниченной ответственностью Сертум-Про', STREET='улица Ульяновская, д. 13, литер А, офис 209 Б', L=Екатеринбург, S=66 Свердловская область, C=RU, ИНН=006673240328, ОГРН=1116673008539, E=ca@sertum.ru",
        //           "subjectName": "CN='ФГБВОУ ВО АКАДЕМИЯ ГРАЖДАНСКОЙ ЗАЩИТЫ МЧС РОССИИ', SN=Вихристюк, G=Светлана Олеговна, C=RU, S=50 Московская область, L=Химки, STREET=НЕТ, O='ФГБВОУ ВО АКАДЕМИЯ ГРАЖДАНСКОЙ ЗАЩИТЫ МЧС РОССИИ', T=Специалист ГО второй категории отдела(ОКР), ОГРН=1035009564215, СНИЛС=12513794750, ИНН=771878261500, E=e.artemenko@amchs.ru, OID.1.2.643.100.4=5047011261",
        //           "thumbprint": "F94E89438A1BCACED6A12A5AD90D49BC5BF143EE",
        //           "validFrom": "2021-10-05T15:51:58.000Z",
        //           "validTo": "2023-01-05T14:42:57.000Z",
        //           "inn": "771878261500"
        //       },
        //       {
        //           "_cadesCertificate": {
        //               "objid": 14
        //           },
        //           "name": "ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК",
        //           "issuerName": "CN=Федеральное казначейство, O=Федеральное казначейство, C=RU, L=Москва, STREET='Большой Златоустинский переулок, д. 6, строение 1', ОГРН=1047797019830, ИНН=007710568760, S=г. Москва, E=uc_fk@roskazna.ru",
        //           "subjectName": "CN='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК', T=Директор, SN=Доморацкий, G=Николай Сидорович, O='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК', L=Химки, S=Московская область, C=RU, E=artemenko@novogorsksport.ru, STREET='мкр-н Новогорск, ул. Соколовская, вл. 7', ОГРН=1165047057592, СНИЛС=05745134159, ИНН=005047186913",
        //           "thumbprint": "E7F95ECC098F13B5A473B30DD99CC2902EF0F795",
        //           "validFrom": "2021-07-21T07:20:28.000Z",
        //           "validTo": "2022-10-21T07:20:28.000Z",
        //           "inn": "5047186913"
        //       },
        //       {
        //           "_cadesCertificate": {
        //               "objid": 15
        //           },
        //           "name": "ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК",
        //           "issuerName": "CN=Федеральное казначейство, O=Федеральное казначейство, C=RU, L=Москва, STREET='Большой Златоустинский переулок, д. 6, строение 1', ОГРН=1047797019830, ИНН=007710568760, S=г. Москва, E=uc_fk@roskazna.ru",
        //           "subjectName": "CN='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК', T='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК', SN=Панкратова, G=Марина Львовна, O='ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ УЧРЕЖДЕНИЕ УЧЕБНО-ТРЕНИРОВОЧНЫЙ ЦЕНТР НОВОГОРСК', L=Химки, S=Московская область, C=RU, E=artemenko@novogorsksport.ru, STREET='мкр. Новогорск, ул. Соколовская вл. 7', ОГРН=1165047057592, СНИЛС=00432922506, ИНН=005047186913",
        //           "thumbprint": "E6668D7D7265DD0A346176A56A2B4874D2297092",
        //           "validFrom": "2021-07-07T09:34:59.000Z",
        //           "validTo": "2022-10-07T09:34:59.000Z",
        //           "inn": "5047186913"
        //       },
        //       {
        //           "_cadesCertificate": {
        //               "objid": 16
        //           },
        //           name: "Барсукова Ольга Сергеевна",
        //           issuerName: "CN=Федеральное казначейство, O=Федеральное казначейство, C=RU, L=Москва, STREET='Большой Златоустинский переулок, д. 6, строение 1', ОГРН=1047797019830, ИНН=007710568760, S=г. Москва, E=uc_fk@roskazna.ru",
        //           subjectName: "CN=Барсукова Ольга Сергеевна, SN=Барсукова, G=Ольга Сергеевна, O=ФЕДЕРАЛЬНОЕ ГОСУДАРСТВЕННОЕ БЮДЖЕТНОЕ ВОЕННОЕ ОБРАЗОВАТЕЛЬНОЕ УЧРЕЖДЕНИЕ ВЫСШЕГО ОБРАЗОВАНИЯ АКАДЕМИЯ ГРАЖДАНСКОЙ ЗАЩИТЫ МИНИСТЕРСТВА РОССИЙСКОЙ ФЕДЕРАЦИИ ПО ДЕЛАМ ГРАЖДАНСКОЙ ОБОРОНЫ, ЧРЕЗВЫЧАЙНЫМ СИТУАЦИЯМ И ЛИКВИДАЦИИ ПОСЛЕДСТВИЙ СТИХИЙНЫХ БЕДСТВИЙ, L=Химки, S=Московская область, C=RU, E=e.artemenko@amchs.ru, СНИЛС=16594021073, ИНН=5047218298",
        //           thumbprint: "DDDE9314B6EE8C279ADEB8B160229537FF94CA84",
        //           validFrom: "2021-02-11T12:02:16.000Z",
        //           validTo: "2022-05-11T12:02:16.000Z",
        //           inn: "732592741503"
        //       }
        //   ]
        // this.arr = [
        //   {
        //     _cadesCertificate: {
        //       objid: 12
        //     },
        //     subjectName:
        //       "CN='ООО АСПЕКТ', O='ООО АСПЕКТ', L=ГОРОД САНКТ-ПЕТЕРБУРГ, S=78 Санкт-Петербург, C=RU, SN=ШАБАНЕВИЧ, G=ТАТЬЯНА АЛЕКСАНДРОВНА, STREET='УЛИЦА ГЕЛЬСИНГФОРССКАЯ,4-1', INN=7733296577, OGRN=1037804025379, SNILS=02419340422, T=Генеральный директор, UnstructuredName='INNLE=7802195283/INN=7733296577/KPP=780201001/OGRN=1037804025379', e=aspekt.spb2015@mail.ru, OID.1.2.643.100.4=7802195283",
        //     thumbprint: "C2E477AFCB79CE8C23E499B0064310AB2F7E3D5A",
        //     validFrom: "2021-10-11T08:20:52.000Z",
        //     validTo: "2023-01-11T08:30:52.000Z",
        //     inn: "7733296577"//7802195283
        //   },
        //   {
        //     _cadesCertificate: {
        //       objid: 13
        //     },
        //     subjectName:
        //       "CN=ПОЛЕЦКИЙ ИГОРЬ СЛАВЬЕВИЧ, O=ИП ПОЛЕЦКИЙ ИГОРЬ СЛАВЬЕВИЧ, L=г. Санкт-Петербург, S=78 Санкт-Петербург, C=RU, SN=ПОЛЕЦКИЙ, G=ИГОРЬ СЛАВЬЕВИЧ, INN=601701867600, SNILS=08406773379, OGRNIP=313784703600290, UnstructuredName='INN=601701867600/OGRNIP=313784703600290', e=igorslav67@mail.ru",
        //     thumbprint: "5C95C59FE53DD51378484411538B4D56F8A9C8AD",
        //     validFrom: "2021-09-16T07:36:28.000Z",
        //     validTo: "2022-12-16T07:46:28.000Z",
        //     inn: "INN=601701867600/OGRNIP=313784703600290"
        //   },
        //   {
        //     _cadesCertificate: {
        //       objid: 14
        //     },
        //     subjectName:
        //       "CN='ООО АСПЕКТ-МЕД', O='ООО АСПЕКТ-МЕД', L=ГОРОД САНКТ-ПЕТЕРБУРГ, S=78 Санкт-Петербург, C=RU, SN=НОВОСЕЛЬЦЕВА, G=ЛАРИСА ГРИГОРЬЕВНА, STREET='УЛИЦА ГЕЛЬСИНГФОРССКАЯ,4, 1', INN=780227812374, OGRN=1137847053046, SNILS=12336695357, UnstructuredName='INNLE=7802815498/INN=780227812374/KPP=780201001/OGRN=1137847053046', T=Генеральный директор, e=aspekt-med.spb@mail.ru, OID.1.2.643.100.4=7802815498",
        //     thumbprint: "355AE549BBA66E609263C510380876F405E74811",
        //     validFrom: "2021-09-15T09:08:45.000Z",
        //     validTo: "2022-09-15T09:18:45.000Z",
        //     inn: "7802815498",
        //     ogrn_count:
        //       "INNLE=7802815498/INN=780227812374/KPP=780201001/OGRN=1137847053046"
        //   },
        //   {
        //     _cadesCertificate: {
        //       objid: 15
        //     },
        //     subjectName:
        //       "CN=ДРИЛЬ АНЖЕЛИКА ИВАНОВНА, O=ИП ДРИЛЬ АНЖЕЛИКА ИВАНОВНА, L=Великий Новгород, S=53 Новгородская область, C=RU, SN=ДРИЛЬ, G=АНЖЕЛИКА ИВАНОВНА, INN=532121658834, SNILS=07550539067, UnstructuredName='INN=532121658834/OGRNIP=314532104500023', OGRNIP=314532104500023, e=ip.dril.anzhelika@gmail.com",
        //     thumbprint: "2C85D89A4A979005F098C95D40A97BDC0427A12F",
        //     validFrom: "2021-10-19T08:16:47.000Z",
        //     validTo: "2022-10-19T08:26:47.000Z",
        //     inn: "INN=532121658834/OGRNIP=314532104500023",
        //     ogrn_count: "314532104500023"
        //   }
        // ];
        // console.log(this.arr);
        // let structureInnFunc = (el, i, num) => {
        //     if(num === 'none'){
        //         el = el.substring(el.indexOf("=") + 1);
        //     }else{
        //         el=el.replace(/\D+/g,"")
        //     }
        //   //console.log("el" + "     " + el);
        //   if (el.length === 12 && el.substring(0, 2) == "00") {
        //     el = el.substring(2);
        //   }
        //   if (el.length === 14 && el.substring(0, 2) == "00") {
        //     el = el.substring(2);
        //   }
        //   //console.log("final_el" + "     " + el);
        //   this.$set(this.arr[i], "inn", el);
        //   this.innArr.push(el);
        // };
        // let addInnFunc = (el, i) => {
        //   console.log('addInnFunc!!');
        //   console.log(el);
        //   let structure = el.split("/");
        //   //console.log(structure);
        //   structure.forEach(el => {
        //       if (el.indexOf("INNLE") !== -1) {
        //           //console.log('INNLE')
        //           structureInnFunc(el, i);
        //       }
        //     if (el.indexOf("ИНН") !== -1) {
        //      // console.log('ИНН')
        //       structureInnFunc(el, i);
        //     }
        //     if (el.indexOf("INN") !== -1) {
        //       //console.log("INN");
        //       //console.log(el)
        //       structureInnFunc(el, i);
        //     }
        //     if (el.indexOf("inn") !== -1) {
        //      // console.log("inn");
        //       structureInnFunc(el, i);
        //     }
        //     if (el.indexOf("инн") !== -1) {
        //       //console.log("инн");
        //       structureInnFunc(el, i);
        //     }
        //     if (el.indexOf("1.2.643.100.4") !== -1) {
        //       //console.log("1.2.643.100.4");
        //       structureInnFunc(el, i, 'none');
        //     }
        //     if (el.indexOf("1.2.643.3.131.1.1") !== -1) {
        //      // console.log("1.2.643.3.131.1.1");
        //       structureInnFunc(el, i, 'none');
        //     }
        //   });
        // };
        // let structureOgrnFunc = (el, i, num) => {
        //    // console.log('structureOgrnFunc!!!')
        //     if(num === 'none'){
        //         el = el.substring(el.indexOf("=") + 1);
        //     }else{
        //         el=el.replace(/\D+/g,"")
        //     }
        //  //
        //
        //  // console.log("ОГРН" + "    " + el);
        //   this.$set(this.arr[i], "ogrn_count", el);
        // };
        // let addOgrnFunc = (el, i) => {
        //   //  console.log('addOgrnFunc!!!')
        //   let structure = el.split("/");
        //  // console.log(structure);
        //   structure.forEach(el => {
        //    //   console.log(el)
        //     if (el.indexOf("ОГРН") !== -1) {
        //      // console.log("ОГРН");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("OGRN") !== -1) {
        //     //  console.log("OGRN");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("огрн") !== -1) {
        //      // console.log("огрн");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("ogrn") !== -1) {
        //      // console.log("ogrn");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("1.2.643.100.1") !== -1) {
        //      // console.log("1.2.643.100.1");
        //       structureOgrnFunc(el, i, 'none');
        //     }
        //     if (el.indexOf("ОГРНИП") !== -1) {
        //      // console.log("ОГРНИП");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("OGRNIP") !== -1) {
        //       //console.log("OGRNIP");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("огрнип") !== -1) {
        //      // console.log("огрнип");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("ogrnip") !== -1) {
        //      // console.log("ogrnip");
        //       structureOgrnFunc(el, i);
        //     }
        //     if (el.indexOf("1.2.643.100.5") !== -1) {
        //      // console.log("1.2.643.100.5");
        //       structureOgrnFunc(el, i, 'none');
        //     }
        //   });
        // };
        // if (this.arr.length > 0) {
        //   for (let i = 0; i < this.arr.length; i++) {
        //     let ass = this.arr[i].subjectName.split(",");
        //     ass.forEach(el => {
        //         if (el.indexOf("INNLE") !== -1) {
        //             //console.log('INNLE')
        //             addInnFunc(el, i);
        //         }
        //       if (el.indexOf("ИНН") !== -1) {
        //         //console.log('ИНН')
        //         addInnFunc(el, i);
        //       }
        //       if (el.indexOf("INN") !== -1) {
        //         //console.log("INN");
        //         //console.log(el)
        //         addInnFunc(el, i);
        //       }
        //       if (el.indexOf("inn") !== -1) {
        //        // console.log("inn");
        //         addInnFunc(el, i);
        //       }
        //       if (el.indexOf("инн") !== -1) {
        //        // console.log("инн");
        //         addInnFunc(el, i);
        //       }
        //       if (el.indexOf("1.2.643.100.4") !== -1) {
        //        // console.log("1.2.643.100.4");
        //         addInnFunc(el, i);
        //       }
        //       if (el.indexOf("1.2.643.3.131.1.1") !== -1) {
        //        // console.log("1.2.643.3.131.1.1");
        //         addInnFunc(el, i);
        //       }
        //
        //       if (el.indexOf("ОГРН") !== -1) {
        //        // console.log("ОГРН");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("OGRN") !== -1) {
        //        // console.log("OGRN");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("огрн") !== -1) {
        //        // console.log("огрн");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("ogrn") !== -1) {
        //        // console.log("ogrn");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("1.2.643.100.1") !== -1) {
        //        // console.log("1.2.643.100.1");
        //         addOgrnFunc(el, i);
        //       }
        //
        //       if (el.indexOf("ОГРНИП") !== -1) {
        //        // console.log("ОГРНИП");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("OGRNIP") !== -1) {
        //        // console.log("OGRNIP");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("огрнип") !== -1) {
        //        // console.log("огрнип");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("ogrnip") !== -1) {
        //        // console.log("ogrnip");
        //         addOgrnFunc(el, i);
        //       }
        //       if (el.indexOf("1.2.643.100.5") !== -1) {
        //        // console.log("1.2.643.100.5");
        //         addOgrnFunc(el, i);
        //       }
        //     });
        //   }
        // }
        // console.log(this.innArr);
        // getinfo({ inns: this.innArr, id: this.$store.state.helper.id }).then(
        //   resp => {
        //     if (resp.data.error) {
        //       this.show = true;
        //     } else {
        //       console.log('YES!!!!!!!!!!!!!!')
        //       this.ecp = "yes";
        //       this.banks = resp.data.data.banks;
        //       this.noSignDocument = resp.data.data.nosign;
        //       this.offer = resp.data.data.offer;
        //       this.offers = resp.data.data.offers;
        //       this.links = resp.data.data.links;
        //       this.form = resp.data.data.form;
        //     }
        //   }
        // );
        // return;

        //конец удалить
        (async () => {
          try {
            let certificates = new Certificate();
            certificates = await getUserCertificates();
            this.arr = certificates;
            //console.log('certificates');
            //console.log(this.arr);
            //this.innArr = ["7733296577"]; //тут пустой должен быть
            //   this.arr=[]
              let structureInnFunc = (el, i, num) => {
                  //вычленяем цифры но если ключ имел вид типа "1.2.643.100.4", то вырезаем по =,если нет регулярным выражением
                  if(num === 'none'){
                      el = el.substring(el.indexOf("=") + 1);
                  }else{
                      el=el.replace(/\D+/g,"")
                  }
                  //console.log("el" + "     " + el);
                  if (el.length === 12 && el.substring(0, 2) == "00") {
                      el = el.substring(2);
                  }
                  if (el.length === 14 && el.substring(0, 2) == "00") {
                      el = el.substring(2);
                  }
                  //console.log("final_el" + "     " + el);
                  this.$set(this.arr[i], "inn", el);
                  this.innArr.push(el);
              };
              let addInnFunc = (el, i) => {
                  // console.log('addInnFunc!!');
                  //тк могут быть элементы типа UnstructuredName="INNLE=7802195283/INN=780410544773/KPP=780201001/OGRN=1037804025379"
                  //я еще разбиваю их на элементы по / и опять ищу все варианты ИНН(огрн ф другой функции) а далее уже вызываю функцию вычленения цифр
                  let structure = el.split("/");
                  //console.log(structure);
                  structure.forEach(el => {
                      if (el.indexOf("INNLE") !== -1) {
                          //console.log('INNLE')
                          structureInnFunc(el, i);
                      }
                      if (el.indexOf("ИНН") !== -1) {
                          // console.log('ИНН')
                          structureInnFunc(el, i);
                      }
                      if (el.indexOf("INN") !== -1) {
                          //console.log("INN");
                          //console.log(el)
                          structureInnFunc(el, i);
                      }
                      if (el.indexOf("inn") !== -1) {
                          // console.log("inn");
                          structureInnFunc(el, i);
                      }
                      if (el.indexOf("инн") !== -1) {
                          //console.log("инн");
                          structureInnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.4") !== -1) {
                          //console.log("1.2.643.100.4");
                          structureInnFunc(el, i, 'none');
                      }
                      if (el.indexOf("1.2.643.3.131.1.1") !== -1) {
                          // console.log("1.2.643.3.131.1.1");
                          structureInnFunc(el, i, 'none');
                      }
                  });
              };

              let structureOgrnFunc = (el, i, num) => {
                  // console.log('structureOgrnFunc!!!')
                  //вычленяем цифры но если ключ имел вид типа "1.2.643.100.4", то вырезаем по =,если нет регулярным выражением
                  if(num === 'none'){
                      el = el.substring(el.indexOf("=") + 1);
                  }else{
                      el=el.replace(/\D+/g,"")
                  }
                  //

                  // console.log("ОГРН" + "    " + el);
                  this.$set(this.arr[i], "ogrn_count", el);
              };
              let addOgrnFunc = (el, i) => {
                  //  console.log('addOgrnFunc!!!')
                  //тк могут быть элементы типа UnstructuredName="INNLE=7802195283/INN=780410544773/KPP=780201001/OGRN=1037804025379"
                  //я еще разбиваю их на элементы по / и опять ищу все варианты ОГРН(инн ф другой функции) а далее уже вызываю функцию вычленения цифр
                  let structure = el.split("/");
                  // console.log(structure);
                  structure.forEach(el => {
                      //   console.log(el)
                      if (el.indexOf("ОГРН") !== -1) {
                          // console.log("ОГРН");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("OGRN") !== -1) {
                          //  console.log("OGRN");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("огрн") !== -1) {
                          // console.log("огрн");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("ogrn") !== -1) {
                          // console.log("ogrn");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.1") !== -1) {
                          // console.log("1.2.643.100.1");
                          structureOgrnFunc(el, i, 'none');
                      }

                      if (el.indexOf("ОГРНИП") !== -1) {
                          // console.log("ОГРНИП");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("OGRNIP") !== -1) {
                          //console.log("OGRNIP");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("огрнип") !== -1) {
                          // console.log("огрнип");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("ogrnip") !== -1) {
                          // console.log("ogrnip");
                          structureOgrnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.5") !== -1) {
                          // console.log("1.2.643.100.5");
                          structureOgrnFunc(el, i, 'none');
                      }
                  });
              };;


            if (this.arr.length > 0) {
              for (let i = 0; i < this.arr.length; i++) {
                let ass = this.arr[i].subjectName.split(",");
                  ass.forEach(el => {
                      //прохожу по всем вариантам инн и огрн и вызываю функцию, которая должна вычлинить числа из элементов
                      if (el.indexOf("INNLE") !== -1) {
                          //console.log('INNLE')
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("ИНН") !== -1) {
                          //console.log('ИНН')
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("INN") !== -1) {
                          //console.log("INN");
                          //console.log(el)
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("inn") !== -1) {
                          // console.log("inn");
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("инн") !== -1) {
                          // console.log("инн");
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.4") !== -1) {
                          // console.log("1.2.643.100.4");
                          addInnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.3.131.1.1") !== -1) {
                          // console.log("1.2.643.3.131.1.1");
                          addInnFunc(el, i);
                      }

                      if (el.indexOf("ОГРН") !== -1) {
                          // console.log("ОГРН");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("OGRN") !== -1) {
                          // console.log("OGRN");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("огрн") !== -1) {
                          // console.log("огрн");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("ogrn") !== -1) {
                          // console.log("ogrn");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.1") !== -1) {
                          // console.log("1.2.643.100.1");
                          addOgrnFunc(el, i);
                      }

                      if (el.indexOf("ОГРНИП") !== -1) {
                          // console.log("ОГРНИП");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("OGRNIP") !== -1) {
                          // console.log("OGRNIP");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("огрнип") !== -1) {
                          // console.log("огрнип");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("ogrnip") !== -1) {
                          // console.log("ogrnip");
                          addOgrnFunc(el, i);
                      }
                      if (el.indexOf("1.2.643.100.5") !== -1) {
                          // console.log("1.2.643.100.5");
                          addOgrnFunc(el, i);
                      }
                  });
              }
              //console.log(this.innArr);
              error({ text: this.arr });
              getinfo({
                inns: this.innArr,
                id: this.$store.state.helper.id
              }).then(resp => {
                if (resp.data.error) {
                  // this.show = true;
                  this.ecp = "wronginn";
                } else {
                  this.ecp = "yes";
                  this.banks = resp.data.data.banks;
                  this.noSignDocument = resp.data.data.nosign;
                  this.offer = resp.data.data.offer;
                  this.offers = resp.data.data.offers;
                  this.links = resp.data.data.links;
                  this.form = resp.data.data.form;
                }
              });
            }
            else {
              //this.show = true;
              this.ecp = "noinn";
            }
            //  this.thumbprint = this.arr[0].thumbprint;// не обязательно, что  от нуля действующий
          } catch (err) {
            this.ecp = "noinn";
            error({ text: err.message });
            this.$notify.error({
              title: "Ошибка!!!",
              message: err
            });
          }
        })();
      } else {
        this.ecp = "no";
      }
    },
    async displaySystemInfo() {
      try {
        //начало удалить
        this.systemInfo = {
          ...(await getSystemInfo()),
          isValidSystemSetup: await isValidSystemSetup()
        };
        //конец удалить
        return true;
      } catch (err) {
        error({ text: err.message });
        return false;
      }
    }
  }
};
</script>

<style scoped></style>
